var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMd = function SvgMd(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#66A3FF",
    d: "M8 3.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8m6 3a.6.6 0 0 0 .6-.6V8a.6.6 0 1 0-1.2 0v2.4a.6.6 0 0 0 .6.6m0-6a.6.6 0 1 0 0 1.2h.006a.6.6 0 1 0 0-1.2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMd);
export { ForwardRef as ReactComponent };